import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/** QR image (data URL) for a text payload. */
export function QrImage({ value, size = 220, label }: { value: string; size?: number; label?: string }) {
  const [src, setSrc] = useState('');
  useEffect(() => {
    let alive = true;
    QRCode.toDataURL(value, {
      width: size * 2,
      margin: 1,
      errorCorrectionLevel: 'M',
    })
      .then((u) => alive && setSrc(u))
      .catch(() => setSrc(''));
    return () => {
      alive = false;
    };
  }, [value, size]);
  return src ? (
    <img src={src} width={size} height={size} alt={label ?? value} className="qr-img" />
  ) : (
    <div style={{ width: size, height: size }} />
  );
}
